import GenericDictionaryPage from "./GenericDictionaryPage";
import { getDemandDerivation } from "../api/demandDerivationApi";

export default function DemandDerivation() {
    return (
           <GenericDictionaryPage
                tableKey="demandDerivation"
                fetchData={getDemandDerivation}
                titleKey="genericDic:demandDerivation"
                newButtonLabel={({ t }) =>
                   t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:demandDerivation").toLowerCase()
                   })
                }
           /> 
       );
   }
 